import React, { Component } from 'react';
import { LocationIconBtn, LocationContainer, LocationWrapper, LocationBtnWrapper } from './LocationElements';
import { getTranslatedKey } from '../Utils/TranslateUtils';

export default class Location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locationSelected: false //variable de estado para el boton de localizacion
    };
  }

  /**
   *
   * @desc función para establecer el centro en la ubicación del usuario
   * @param {*} position : ;
   */
  success = (position) => {
    this.props.onDisplayCurrentLocation(position.coords.longitude, position.coords.latitude);
  };

  /**
   * @desc función de estado para obtener la ubicación
   */
  onLocationBtnClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.props.onClickGeolocalitzacioMapa, this.props.onGeolocalitzacioError, {
        enableHighAccuracy: true,
        timeout: 10 * 1000,
        maximumAge: 0
      });
    } else {
      this.props.onGeolocalitzacioError(4);
    }
  };

  render() {
    return (
      <>
        <LocationContainer
          id="Location-Container"
          infoPuntObert={this.props.infoPuntObert}
          alturaBtnLocation={this.props.alturaBtnLocation}
          hideBottomButtons={this.props.hideBottomButtons}>
          <LocationWrapper id="Location-Wrapper">
            <LocationBtnWrapper>
              <LocationIconBtn
                title={getTranslatedKey('locationTitle')}
                onMouseDown={() => this.setState({ locBttnClicked: true })}
                onMouseUp={() => this.setState({ locBttnClicked: false })}
                id="location-btn"
                locationSelected={this.state.locationSelected}
                onClick={() => this.onLocationBtnClick()}
                aria-label={getTranslatedKey('aria_ubicacioBtn')}
                className="location-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  width="26"
                  viewBox="0 0 283.5 283.5"
                  fill={this.state.locBttnClicked ? '#333333' : 'white'}>
                  <path d="M141.7,90.8c28.1,0,50.9,22.8,50.9,50.9s-22.8,50.9-50.9,50.9s-50.9-22.8-50.9-50.9S113.6,90.8,141.7,90.8 M27.8,154.5H1.6V129h26.1C33.5,75.9,75.9,33.5,129,27.8V1.6h25.5v26.1C207.6,33.5,250,75.9,255.7,129h26.1v25.5h-26.1c-5.7,53.1-48.1,95.5-101.2,101.2v26.1H129v-26.1C75.9,250,33.5,207.6,27.8,154.5 M141.7,52.6c-49.2,0-89.1,39.9-89.1,89.1s39.9,89.1,89.1,89.1s89.1-39.9,89.1-89.1S191,52.6,141.7,52.6z"></path>
                </svg>
              </LocationIconBtn>
            </LocationBtnWrapper>
          </LocationWrapper>
        </LocationContainer>
      </>
    );
  }
}
